import { Controller, Helper, Instance, Knot, State } from '@siposdani87/sui-js';
import { app } from '../app';

export class SiteChangesController extends Controller {
    static readonly inject = ['instances'] as const;

    dom: Knot;
    state: State;
    helper: Helper;

    constructor(instances: Instance) {
        super();

        this.dom = instances.dom;
        this.state = instances.state;
        this.helper = instances.helper;
    }

    enter(): void {
        this._initLayout();
    }

    protected _initLayout(): void {
        this._initToolbarButtons();
    }

    private _initToolbarButtons(): void {
        this.helper.iconButton('.btn-landing-page', this.dom, () => {
            this.state.goBack('site.landing-page');
        });
    }
}

export const siteChangesController = app.controller(
    'siteChangesController',
    SiteChangesController,
);
